import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSupplierByIdQuery } from 'api';

export const useLegal = () => {
  const [modalState, setModalState] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data = {} } = useSupplierByIdQuery({ id });
  const onModalStateChange = useCallback(() => setModalState((prevState) => !prevState), []);
  return {
    modalState,
    legal: data.legal || {},
    onModalStateChange,
  };
};
